import { render, staticRenderFns } from "./LandingSection.vue?vue&type=template&id=2ade5314&scoped=true"
import script from "./LandingSection.vue?vue&type=script&lang=js"
export * from "./LandingSection.vue?vue&type=script&lang=js"
import style0 from "./LandingSection.vue?vue&type=style&index=0&id=2ade5314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade5314",
  null
  
)

export default component.exports